import React, { useCallback, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useMappedState } from 'redux-react-hook';
import { GUEST_ROUTES } from 'routes/routes';
import styled from 'styled-components';

import chevron_icon from '../../assets/chevron-down.svg';
import { ANCHORS } from '../../constants/anchors';
import UIHelper from '../../helpers/UIHelper';
import { scrollToAnchor } from '../../utils';

const TextButton = ({ title, onClick }) => {
  return (
    <button
      onClick={event => {
        if (!onClick) {
          return;
        }

        onClick();
        event.preventDefault();
      }}
      style={{
        color: 'rgba(255, 126, 85, 1)',
        textDecoration: 'underline',
        background: 'none',
        border: 'none',
        cursor: 'pointer'
      }}
    >
      {title}
    </button>
  );
};

const getFAQDictionary = (onClickSubscriptionText, onOpenCreateScenarioModal, hasSubscription) => [
  {
    id: 0,
    question: 'How does EroPlay.ai work?',
    answer: (
      <p>
        We immerse the user in an erotic story, where your partner is an artificial intelligence
        powered by fine-tuned language models. We’re continuously enhancing our product to offer you
        the best possible experience and to go beyond the typical AI girl sex chat.
        <br />
        The user can{' '}
        <TextButton
          title="choose a scenario"
          onClick={() => scrollToAnchor(ANCHORS.FEATURED_SCENARIOS)}
        />{' '}
        from a list of pre-made options or create their own from scratch.
      </p>
    )
  },
  {
    id: 1,
    question: 'What is a scenario?',
    answer:
      'Each scenario includes a starting location, a backstory, and characters with specific traits and goals. When the user picks a scenario, they enter a chat at the start of the story. From there, the user controls how the plot unfolds by choosing what to say and do. The AI responds based on the user’s choices, staying in character and true to the situation.'
  },
  {
    id: 2,
    question: 'What are the benefits of the Premium?',
    answer: (
      <p>
        {hasSubscription ? 'The Premium plan' : <TextButton title="The Premium plan" onClick={() => onClickSubscriptionText()} />} gives you
        full access to all scenarios, unlimited messaging, and lets you receive images and GIFs
        without any blurring of intimate parts. You’ll also experience faster responses, more
        advanced AI dialogue, and better answer quality compared to non-subscribers. Plus, when the
        site experiences an overload of users, Premium users get priority in message processing.
        <br />
        With the subscription, you can also create custom scenarios from scratch - choosing
        everything from the number of participants and their personalities to the backstory and
        setting.
      </p>
    )
  },
  {
    id: 3,
    question: 'Сan I create my own scenario?',
    answer: (
      <p>
        Yes, you have a few options:
        <br />
        If you want a quick setup and enjoy surprises, you can give a brief idea, and our AI will
        create the scenario for you.
        <br />
        If you prefer more control, you can customize every detail to match your vision - from
        character looks and personalities to the opening line of your story.
        <br />
        <TextButton title="Just try it!" onClick={() => onOpenCreateScenarioModal()} />
      </p>
    )
  },
  {
    id: 4,
    question: 'What can I do and what can I talk about in the chat?',
    answer: (
      <p>
        You can choose from a variety of{' '}
        <TextButton title="scenarios" onClick={() => scrollToAnchor(ANCHORS.FEATURED_SCENARIOS)} />{' '}
        or {hasSubscription ? 'The Premium plan' : <TextButton title="The Premium plan" onClick={() => onClickSubscriptionText()} />}, each
        with unique features and character traits that shape how events unfold. Every character has
        their own personality, needing a specific approach to match the vibe of the situation - just
        like in real life.
        <br />
        We give you full freedom in your actions and choices; there’s no “right” path to follow. By
        staying true to yourself, you can reach the outcome you want.
      </p>
    )
  },
  {
    id: 5,
    question: 'How much and how often will I be charged for Premium?',
    answer: (
      <div>
        Premium plan cost:
        <ul className="list-inside list-disc">
          <li className="mt-2">1 month: $12.99</li>
          <li className="mt-2">1 year: $89.99 (just $7.49/month, saving you 42% over a year).</li>
        </ul>
        <p>
          <br />
          {hasSubscription ? 'The Premium plan' : <TextButton title="The Premium plan" onClick={() => onClickSubscriptionText()} />} unlocks
          advanced features, with payments billed monthly or annually on your purchase date. You can
          cancel auto-renewal anytime, and your subscription will stay active until the end of the
          current billing period.
          <br />
          We ensure full security for your payment data. All information is sent through secure,
          encrypted channels, making it inaccessible to unauthorized parties. We don’t store or have
          access to your payment details.
        </p>
      </div>
    )
  },
  {
    id: 6,
    question: 'How often do new scenarios appear?',
    answer: `We’re dedicated to adding fresh scenarios, aiming to release 2-3 new stories each week. Our team focuses on making each scenario unique and responsive to our users' needs.
            \nIf there’s a scenario you’d like but don’t see on the site, feel free to reach out with your ideas at support@eroplay.ai. We’ll review your suggestions and get back to you with feedback.
        `
  },
  {
    id: 7,
    question: 'Will there be more scenarios for women, LGBT+ and other minorities?',
    answer: (
      <p>
        Our goal is to create scenarios that satisfy every user's interests. If you don’t see what
        you’re looking for, you can{' '}
        <TextButton title="create your own" onClick={() => onOpenCreateScenarioModal()} />.
        <br />
        Or, if you have ideas you'd like us to bring to life, just reach out at support@eroplay.ai -
        we’d love to hear your feedback!
      </p>
    )
  },
  {
    id: 8,
    question: (
      <p>
        The character behaves <span className="break-all">unnaturally/stupidly/repetitively</span>.
        What to do?
      </p>
    ),
    answer: (
      <p>
        On the free plan, you might notice some limitations since it uses a simpler language model.
        The advanced model comes with high costs, so it’s only available for Premium users.
        <br />
        With a {hasSubscription ? 'The Premium plan' : <TextButton title="The Premium plan" onClick={() => onClickSubscriptionText()} />},
        you get access to our most advanced language model, which we're always working to improve.
      </p>
    )
  },
  {
    id: 9,
    question: 'How to receive photos? Can I ask my interlocutor to send a photo?',
    answer: `The scenarios are set up so that you’ll receive photos as you progress through the story.
            \nKeep in mind that not all scenarios include photos. If a scenario has photographs, it will have a “photo” icon in the upper left corner.
        `
  },
  {
    id: 10,
    question: 'How is the privacy and security of my data handling?',
    answer: `We use advanced encryption methods and secure data storage to ensure that every message remains confidential and accessible only to you.
            \nYour privacy and data security are our top priorities.
            \nWe respect your unique preferences and provide you with a personal space where you can explore and express your desires.
        `
  },
  {
    id: 11,
    question: 'What kind of content is prohibited on the service?',
    answer: (
      <div>
        We allow users to engage with fictional content but strictly prohibit:
        <ul className="list-inside list-disc">
          <li className="mt-2">
            Any form of child pornography; all fictional characters must be at least 18 years old.
          </li>
          <li className="mt-2">Depictions of violence against humans or animals.</li>
          <li className="mt-2">
            Inclusion or mention of real people or public figures in scenarios.
          </li>
          <li className="mt-2">
            Content related to violence, terrorism, excessive cruelty, or any harmful or illegal
            activities.
          </li>
        </ul>
        <p>
          We are committed to providing a safe and respectful platform for self-expression that
          honors the personal and legal boundaries of all users.{' '}
          <Link to={`${GUEST_ROUTES.PRIVACY_POLICY()}#top`}>
            <TextButton title="Here" />
          </Link>{' '}
          Сontent Policy in more detail.
          <br />
          If you encounter any violations, please report them immediately to support@eroplay.ai.
        </p>
      </div>
    )
  }
];

export const FaqPanel = ({ onClickSubscriptionText, onOpenCreateScenarioModal }) => {
  const [opened, setOpened] = useState([]);

  const isDreamRoleOrErogination = UIHelper.isDreamRoleOrErogination();

  const { hasSubscription } = useMappedState(
    useCallback(state => {
      const currentUser = state.users.usersMap.get(state.users.currentUserId);
      const hasSubscription = !!currentUser?.hasSubscription;
      return {
        hasSubscription: hasSubscription
      };
    }, [])
  );

  const FAQ = useMemo(
    () => getFAQDictionary(onClickSubscriptionText, onOpenCreateScenarioModal, hasSubscription),
    [onClickSubscriptionText, onOpenCreateScenarioModal, hasSubscription]
  );


  return (
    <Wrapper>
      <Header id="faq">
        Frequently Asked <span className="text-[rgb(255,126,85)]">Questions</span>
      </Header>
      <FaqPlaceholder>
        {FAQ.map(q => {
          const isOpened = opened.includes(q.id);
          return (
            <QuestionPlaceholder
              key={q.id}
              onClick={() => setOpened(isOpened ? opened.filter(x => x != q.id) : opened.concat(q.id))}
            >
              <div className="flex items-center justify-between space-x-4">
                <Question>
                  {q.question == 'How does EroPlay.ai work?' && isDreamRoleOrErogination
                    ? 'How our site works?'
                    : q.question}
                </Question>
                <img
                  src={chevron_icon}
                  className={`transform transition-transform duration-300 ${isOpened ? 'rotate-180' : ''}`}
                />
              </div>
              <Answer isOpened={isOpened}>{q.answer}</Answer>
            </QuestionPlaceholder>
          );
        })}
      </FaqPlaceholder>
    </Wrapper>
  );
};


const Wrapper = styled.div`
  width: 100%;
  color: white;
`;

const Header = styled.h1`
  font-family: Raleway;
  font-size: 40px;
  font-weight: 700;
  line-height: 42px;
`;

const FaqPlaceholder = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const QuestionPlaceholder = styled.div`
  background-color: rgba(29, 29, 29, 1);
  padding: 24px;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
`;

const Question = styled.div`
  font-family: Nunito Sans;
  font-size: 22px;
  font-weight: 600;
  line-height: 24px;
`;

const Answer = styled.div`
  font-family: Nunito Sans;
  font-size: 18px;
  font-weight: 400;
  line-height: 22px;
  color: rgba(169, 169, 169, 1);
  white-space: pre-line;
  height: 0;
  opacity: 0;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  margin-top: 0;

  ${props => props.isOpened && `
    height: auto;
    opacity: 1;
    margin-top: 16px;
  `}
`;